import { createRouter, createWebHashHistory } from 'vue-router'
import MainLaunch from '@/components/MainLaunch.vue'
import { mainRoutes } from '@/router/main-routes'
import { authGuard } from '@/router/auth-guards'

const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      component: MainLaunch,
      children: mainRoutes
    },
    {
      path: '/results-em/:env/:id',
      name: 'results-em',
      component: () => import('../views/ResultsWrapperEmbedded.vue'),
      beforeEnter: (to, from, next) => {
        const env = to.params.env as string
        if (['ea', 'aai', 'ani'].includes(env)) {
          next()
        } else {
          next(false)
        }
      }
    }
  ]
})

// Global navigation guard
router.beforeEach(authGuard)

export default router
